import { Variants } from "framer-motion"

export const staggerContainer: Variants = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: 0.3,
            delayChildren: 0.2
        }
    },

}

export const fadeInUp: Variants = {
    initial: {
        y: 20,
        opacity: 0
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            ease: "easeInOut"
        }
    }
}

export const loadingAnimate: Variants = {
    initial: {
        opacity: 0,
        visibility: "hidden"
    },

    animate: {
        opacity: 1,
        visibility: "visible",

        transition: {
            ease: "easeInOut",
        }
    }

}